import { useCallback, useState } from 'react';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi';
import { IoCloseCircleOutline } from 'react-icons/io5';

const CardGallery = ({ showGallery, handleShowGallery, packageDestinations, images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const prevImage = useCallback(() => {
    setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  }, [images]);

  const nextImage = useCallback(() => {
    setCurrentImageIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  }, [images]);

  return (
    <aside
      className={`win-galeria-imagenes ${showGallery ? 'display-block' : 'display-none'}`}
      onClick={handleShowGallery}
    >
      <div className="win-galeria-imagenes__container" onClick={(e) => e.stopPropagation()}>
        <div className="win-galeria-imagenes__image">
          <div className="win-galeria-imagenes__close" onClick={handleShowGallery}>
            <IoCloseCircleOutline style={{ fontSize: '1.5rem', cursor: 'pointer' }} />
          </div>
          <img src={images[currentImageIndex]} alt="" />
          {packageDestinations.length > 1 && (
            <div className="win-galeria-imagenes__controls">
              <HiArrowLeft onClick={prevImage} />
              <HiArrowRight onClick={nextImage} />
            </div>
          )}
        </div>
      </div>
    </aside>
  );
};

export default CardGallery;
